import { Dispatch, Middleware, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { MiddlewareAPI } from 'redux';

export type IErrorHandler<D extends Dispatch> = (
  err: Error,
  action: PayloadAction<any>,
  storeApi: MiddlewareAPI<D, RootState>,
) => unknown;

export const errorCatcher = <D extends Dispatch>(
  errorHandler: IErrorHandler<D>,
): Middleware<unknown, RootState, D> => {
  return (storeApi) => (next) => (action) => {
    try {
      return next(action);
    } catch (err) {
      if (err) {
        errorHandler(err as Error, action, storeApi);
      }
      return err;
    }
  };
};
